module.exports = __webpack_public_path__ + "version/1704890033/img/x-bg.54504fa3.png";